export default {
  recaptchaSiteKey: '6Lf8IvUnAAAAAOP7AQkEgdccZh9Pjj0kx7aSXJFM',
  baseUrl: "https://api.ryan-funding.ir"
}
